export default "__VITE_ASSET__nYPlgKrt__"